import React from "react";
import { useLocation } from "react-router-dom";
import success from "../../Assets/success.png";

const KycSuccess = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const transactionId = params.get("unifiedTransactionId") || "YOUR_ID";

  const deepLinkUrl =
    `arthatrack://kyc/callback?unifiedTransactionId=${transactionId}`
    // `https://arthatrack.cloudjiffy.net/digitalKYC/callback?unifiedTransactionId=${transactionId}`;

  return (
    <div
      className="main-content"
      style={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f7f8fa",
        padding: 16,
      }}
    >
      <div
        className="card"
        style={{
          maxWidth: 400,
          width: "100%",
          padding: 32,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          borderRadius: 12,
          textAlign: "center",
          background: "#fff",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
          <img
            src={success}
            alt="KYC"
            style={{ width: 60, height: 60 }}
          />
        </div>
        <h2 style={{ marginBottom: 12, color: "#4a90e2" }}>KYC Process Complete</h2>
        <p style={{ marginBottom: 24 }}>
          Your KYC process has been submitted.<br />
          Please click the button below to open the app and check your KYC status.
        </p>
        <a
          href={deepLinkUrl}
          style={{
            display: "inline-block",
            background: "#4a90e2",
            color: "#fff",
            padding: "12px 28px",
            borderRadius: 8,
            fontSize: 16,
            textDecoration: "none",
            fontWeight: 600,
            marginBottom: 12,
            transition: "background 0.2s"
          }}
        >
          Open in App
        </a>
        <div style={{ marginTop: 16, color: "#888", fontSize: 14 }}>
          If nothing happens, please make sure the app is installed.
        </div>
      </div>
    </div>
  );
};

export default KycSuccess;